import { StatusesType } from '../../../../types';

export interface MessageManagerRes {
  id: number;
  status: StatusesType;
  campaignName: string;
  revDate: string;
  appType: 'Monthly Statement' | 'Daily Letters' | string;
  scheduledDates: ScheduledDates;
}

export interface ScheduledDates {
  from: string;
  to: string;
}

function adjustDate(dateStr: string) {
  const date = new Date(dateStr);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  date.setFullYear(currentYear);
  date.setMonth(currentMonth - 1);

  return date.toISOString();
}

export const MESSAGE_MANAGER_LIST_STORAGE_KEY = 'messageManagerData';

export const initialMessageManagerData: MessageManagerRes[] = [
  {
    id: 108,
    status: 'draft',
    campaignName: 'Test Campaign',
    revDate: adjustDate('2024-01-04'),
    appType: 'Monthly Statement',
    scheduledDates: {
      from: adjustDate('2024-01-10T00:00:00Z'),
      to: adjustDate('2024-01-16T00:00:00Z'),
    },
  },
  {
    id: 106,
    status: 'draft',
    campaignName: 'VISA Classic - Refinance and save money',
    revDate: adjustDate('2024-01-06'),
    appType: 'Monthly Statement',
    scheduledDates: {
      from: adjustDate('2024-01-01T00:00:00Z'),
      to: adjustDate('2024-02-21T00:00:00Z'),
    },
  },
  {
    id: 104,
    status: 'draft',
    campaignName: 'Visa Business– REWARDS',
    revDate: adjustDate('2024-01-07'),
    appType: 'Monthly Statement',
    scheduledDates: {
      from: adjustDate('2024-02-10T00:00:00Z'),
      to: adjustDate('2024-02-17T00:00:00Z'),
    },
  },
  {
    id: 111,
    status: 'draft',
    campaignName: 'Visa Sweepstakes and closed accounts',
    revDate: adjustDate('2024-01-08'),
    appType: 'Monthly Statement',
    scheduledDates: {
      from: adjustDate('2024-02-21T00:00:00Z'),
      to: adjustDate('2024-02-22T00:00:00Z'),
    },
  },
  {
    id: 187,
    status: 'scheduled',
    campaignName: 'Visa Gold - Demo Auto Sale',
    revDate: adjustDate('2024-01-10'),
    appType: 'Monthly Statement',
    scheduledDates: {
      from: adjustDate('2024-01-04T00:00:00Z'),
      to: adjustDate('2024-01-06T00:00:00Z'),
    },
  },
  {
    id: 105,
    status: 'completed',
    campaignName: 'Visa Classic- Back to School Shopping',
    revDate: adjustDate('2024-01-11'),
    appType: 'Monthly Statement',
    scheduledDates: {
      from: adjustDate('2024-01-07T00:00:00Z'),
      to: adjustDate('2024-02-08T00:00:00Z'),
    },
  },
  {
    id: 115,
    status: 'completed',
    campaignName: 'Save Money on Your Loans',
    revDate: adjustDate('2024-01-16'),
    appType: 'Daily Letters',
    scheduledDates: {
      from: adjustDate('2024-01-10T00:00:00Z'),
      to: adjustDate('2024-02-11T00:00:00Z'),
    },
  },
];

function loadMessageManagerData(): MessageManagerRes[] {
  try {
    const stored = localStorage.getItem(MESSAGE_MANAGER_LIST_STORAGE_KEY);

    if (stored) {
      return JSON.parse(stored) as MessageManagerRes[];
    }
  } catch {
    // Use initial campaigns when storage is empty or invalid.
  }

  return structuredClone(initialMessageManagerData);
}

export const messageManagerData: MessageManagerRes[] = loadMessageManagerData();

function persistMessageManagerData() {
  localStorage.setItem(MESSAGE_MANAGER_LIST_STORAGE_KEY, JSON.stringify(messageManagerData));
}

export function getCampaignById(id: number | string | undefined) {
  if (id === undefined || id === '') return undefined;

  return messageManagerData.find(campaign => campaign.id === Number(id));
}

export function getNextCampaignId() {
  return messageManagerData.reduce((maxId, campaign) => Math.max(maxId, campaign.id), 0) + 1;
}

function getListAppType(type?: string) {
  if (type === 'quarterly') return 'Quarterly';
  if (type === 'annually') return 'Annually';

  return 'Monthly Statement';
}

export function upsertCampaignFromBuilder(
  id: number,
  payload: {
    campaignName: string;
    type?: string;
    startDate: Date;
    endDate: Date;
  },
) {
  const nextCampaign: MessageManagerRes = {
    id,
    status: 'draft',
    campaignName: payload.campaignName.trim() || 'New Campaign',
    revDate: new Date().toISOString(),
    appType: getListAppType(payload.type),
    scheduledDates: {
      from: payload.startDate.toISOString(),
      to: payload.endDate.toISOString(),
    },
  };
  const existingIndex = messageManagerData.findIndex(campaign => campaign.id === id);

  if (existingIndex >= 0) {
    messageManagerData[existingIndex] = {
      ...messageManagerData[existingIndex],
      ...nextCampaign,
    };
  } else {
    messageManagerData.unshift(nextCampaign);
  }

  persistMessageManagerData();
}
